import $ from 'jquery';
import Popup from '../utilities/Popup';
import Api from '../utilities/Api';

let inProgress = false;

$('.order-form').submit(async function (e) {
    e.preventDefault();
    if (inProgress) {
        return;
    }
    inProgress = true;

    Popup.showContent(
        'Оформление заказа',
        'Идёт оформление заказа, пожалуйста подождите<span class="popup__loader"></span>',
        600,
        false
    );

    const response = await Api.post('/api/v2/order/create/', $(this).serializeObject());

    if (response.isError) {
        Popup.showContent(
            'Ошибка',
            response.error,
            600,
            true
        );
    }
});
